module.exports = __webpack_public_path__ + "static/media/ChiswickHeadline-Extralight-Web.fd8416d3.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/ChiswickHeadline-Extralight-Web.eot
// module id = 72
// module chunks = 0